import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getFavorites = createAsyncThunk(
  "favorites/get",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`${config.API_URL_V2}/favorites/`, {
        params, // { page, per_page, search }
      });
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

export const addFavorite = createAsyncThunk(
  "favorites/add_item",
  async (menuItemId, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/favorites/items/`,
        {
          menu_item_id: menuItemId,
        }
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

export const removeFavorite = createAsyncThunk(
  "favorites/remove_item",
  async (menuItemId, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(
        `${config.API_URL_V2}/favorites/items/${menuItemId}/`
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);
